export interface PersonaFisicaModel {
  datiPersonaFisica: DatiPersonaFisicaModel,
  domicili: Array<DomicilioModel>,
  recapiti: Array<RecapitoModel>,
  residenza: ResidenzaPersonaFisicaModel
}

export interface DatiAnagPersonaFisicaModel {
	infoAnagrafiche: InfoAnagrafichePFModel;
	infoNascita: InfoNascitaPFModel;
}

export interface InfoNascitaPFModel {
	comuneNascita: string;
	provinciaNascita: string;
	dataNascita: Date;
	// nazionalita: string;
	// sesso: string;
}


export interface InfoAnagrafichePFModel {
	nome: string;
	cognome: string;
	codFiscale: string;
	// nazionalita: string;
}

export interface DatiPersonaFisicaModel {
  cittadinanze: Array<CittadinanzaModel>,
  codiceFiscale: string,
  cognome: string,
  comuneNascita: ComuneModel,
  dataNascita: string,
  dataDecesso: string,
  estero: boolean,
  id: string,
  nazioneNascita: NazioneModel,
  nome: string,
  provinciaNascita: LocalitaModel,
  regioneNascita: LocalitaModel,
  tipoSesso: TipologicaModel,
  tipoStatoCivile: TipologicaModel,
  dataNascitaFull: Date,
  dataNascitaNotZ: string
}

export interface RecapitoModel {
  id: string,
  preferito: boolean,
  recapito: string,
  tipoRecapito: TipologicaModel
}

export interface DomicilioModel {
  id: string,
  indirizzo: ResidenzaPersonaFisicaModel,
  preferito: boolean,
  tipoDomicilio: TipologicaModel
}

export interface ResidenzaPersonaFisicaModel {
  cap: string,
  civico: string,
  comune: ComuneModel,
  estero: boolean,
  id: string,
  indirizzo: string,
  nazione: NazioneModel,
  presso: string,
  provincia: LocalitaModel,
  regione: LocalitaModel
}

export interface LocalitaModel {
  denominazione: string,
  sigla: string
}

export interface ComuneModel {
  codiceCatastale: string,
  codiceIstat: string,
  denominazione: string,
  //TODO
  // siglaProvincia: string
}

export interface CittadinanzaModel {
  denominazione: string,
  sigla: string
}

export interface TipologicaModel {
  codice: string,
  descrizione: string
}

export interface NazioneModel {
  id: string;
  codiceCatastale: string,
  denominazione: string,
  sigla: string
}

export const EMPTY_INDIRIZZO_MODEL: ResidenzaPersonaFisicaModel = {
  cap: '',
  civico: '',
  comune: {
    codiceCatastale: '',
    codiceIstat: '',
    denominazione: ''
  },
  estero: false,
  id: null,
  indirizzo: '',
  nazione: {
    codiceCatastale: '',
    denominazione: '',
    sigla: '',
    id: ''
  },
  presso: '',
  provincia: {
    denominazione: '',
    sigla: ''
  },
  regione: {
    denominazione: '',
    sigla: ''
  }
}

export interface ContattoModel {
  email: string;
	pec: string;
	telefono: string;
}

export interface IndirizzoModel {
	strada: StradaModel;
	localita: LocalitaIndirizzzoModel;
}

export interface StradaModel {
	tipoToponimo: string;
	inidirizzo: string;
	civico: string;
}

export interface LocalitaIndirizzzoModel {
	comune: string;
	provincia: string;
	cap: string;
	nazione: string;
}
export interface VerificaPfResponseDTO {
	residenza: ResidenzaPersonaFisicaModel;
	valido:	boolean;
}
